export default __webpack_public_path__ + "static/media/trending-icon.68948aff.png";